// ===============================================================
// AdminBadge — Inline badge with background color
// ===============================================================

interface AdminBadgeProps {
  bg: string;
  color: string;
  children: React.ReactNode;
}

export function AdminBadge({ bg, color, children }: AdminBadgeProps) {
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: 4,
        fontSize: 11,
        fontWeight: 600,
        background: bg,
        color,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}
